// 密码规则校验
export const passwordRegularValid = {
  /**
   * ^ 匹配一行的开头位置
   * (?=.*[a-z]) 至少一个小写字母
   * (?=.*[A-Z]) 至少一个大写字母
   * (?=.*\d) 至少一个数字
   * [^] 其他任意字符
   * {6,14} 6到14位
   * $ 匹配行结尾位置
   */
  pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{6,14}$/,
  message: '密码需介于6-14个字母和数字且必须包含大小写字母和数字',
  trigger: 'blur'
}

// 邮箱格式校验
export const emailRegularValid = {
  pattern: /^[A-Za-z0-9]+([_\.][A-Za-z0-9]+)*@([A-Za-z0-9\-]+\.)+[A-Za-z]{2,6}$/,
  message: '请输入正确的电子邮箱格式',
  trigger: ['blur']
}

// 手机号规则校验
export const mobileRegularValid = {
  pattern: /^[0-9]{11}$/,
  message: '请输入正确的11位手机号码',
  trigger: ['blur']
}

//
export function requiredRule(msg, pattern = '', trigger = 'blur') {
  if (pattern) {
    return {
      required: true,
      pattern,
      message: msg,
      trigger: trigger
    }
  }
  return {
    required: true,
    message: msg,
    trigger: trigger
  }
}
